module.exports = __webpack_public_path__ + "img/face-persevering.397e65fb.svg";